import axios from "axios";

const baseURL =
  import.meta.env.VITE_API_URL;
  // import.meta.env.VITE_API_URL || "https://api_test.mishnatyosef.org/api";

const axiosInstance = axios.create({
  baseURL,
  // timeout: 5000, // Set the request timeout to 5 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.data.error === "token_expired" &&
      !originalRequest._retry
    ) {
      // Access token has expired
      originalRequest._retry = true;
      // Perform logout
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Redirect to the login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
